document.addEventListener('DOMContentLoaded', () => {

  // --- 1. SAFE MOBILE MENU FIX ---
  document.addEventListener('click', (e) => {
    const summary = e.target.closest('.product__accordion summary');
    if (summary && window.innerWidth < 750) {
      const details = summary.parentElement;
      if (details.hasAttribute('open')) return;
      e.stopPropagation();
    }
  });

  const SLOT_ID = 45504958103738;    
  const MID_ID = 45507053617338;     
  const PREMIUM_ID = 45507055943866; 
  const UPGRADE_IDS = [MID_ID, PREMIUM_ID];

  // --- 2. THE STABLE ENFORCER ---
  async function enforceBundle() {
    const response = await fetch('/cart.js?v=' + Date.now());
    const cart = await response.json();
    
    const slot = cart.items.find(item => item.variant_id === SLOT_ID);
    const upgradeItem = cart.items.find(item => UPGRADE_IDS.includes(item.variant_id));

    if (slot && slot.properties) {
      const tier = slot.properties['Build Tier'];
      if ((tier === 'Mid' || tier === 'Premium') && !upgradeItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: slot.key, quantity: 0 })
        });
        window.location.href = '/cart?v=reset';
        return;
      }
    }

    if (!slot && upgradeItem) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: upgradeItem.key, quantity: 0 })
      }).then(() => {
        window.location.href = '/cart?v=cleared-' + Date.now();
      });
    }
  }

  const { fetch: originalFetch } = window;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = args[0];
    if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update'))) {
      setTimeout(enforceBundle, 350); 
    }
    return response;
  };

  enforceBundle();

  // --- BUTTON REFERENCE (DECLARE ONCE) ---
  const customBtn = document.getElementById('cyo-submit-btn');

  // --- 3A. SLOT AVAILABILITY CHECK ON LOAD ---
  async function checkSlotAvailability() {
    if (!customBtn) return;

    try {
      const variant = await fetch(`/variants/${SLOT_ID}.js`)
        .then(res => res.json());

      if (!variant.available) {
        customBtn.disabled = true;
        customBtn.innerText = "All Production Slots Filled";
        customBtn.classList.add("cyo-sold-out");

        if (!document.querySelector('.cyo-sold-out-message')) {
          const msg = document.createElement('div');
          msg.className = 'cyo-sold-out-message';
          msg.innerText = "All current production slots are filled. Please check back soon.";
          customBtn.parentNode.appendChild(msg);
        }
      }

    } catch (err) {
      console.warn("Slot availability check failed:", err);
    }
  }

  checkSlotAvailability();

  // --- 3. THE BUY BUTTON LOGIC ---
  if (customBtn) {
    customBtn.onclick = async (e) => {
      e.preventDefault();

      const container = document.querySelector('[data-cyo]');
      const tierInput = container.querySelector('input[name="cyo_tier"]:checked');

      if (!tierInput) {
        alert("Please select a Build Tier.");
        return;
      }

      customBtn.disabled = true;
      customBtn.innerText = "Securing Build Slot...";

      const properties = {
        'Build Tier': tierInput.value.charAt(0).toUpperCase() + tierInput.value.slice(1)
      };

      container.querySelectorAll('select').forEach(select => {
        if (select.value) {
          const key = select.name.replace('properties[', '').replace(']', '');
          properties[key] = select.value;
        }
      });

      let items = [
        { id: SLOT_ID, quantity: 1, properties: properties }
      ];

      if (tierInput.value === 'mid') {
        items.push({
          id: MID_ID,
          quantity: 1,
          properties: {
            "_cyo_flag": "true",
            "Note": "This Upgrade Charge expanded your Mid Tier build options.",
            " ": " ",
            "Removal": "To remove this charge, delete the Production Slot and return to the Create Your Own page."
          }
        });
      }

      if (tierInput.value === 'premium') {
        items.push({
          id: PREMIUM_ID,
          quantity: 1,
          properties: {
            "_cyo_flag": "true",
            "Note": "This Upgrade Charge expanded your Premium Tier build options.",
            " ": " ",
            "Removal": "To remove this charge, delete the Production Slot and return to the Create Your Own page."
          }
        });
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });

      const responseText = await response.text();
      console.log("STATUS:", response.status);
      console.log("RAW RESPONSE:", responseText);

      if (!response.ok) {

        const errorData = JSON.parse(responseText);

        if (errorData.description && errorData.description.includes("sold out")) {
          customBtn.disabled = true;
          customBtn.innerText = "All Production Slots Filled";
          customBtn.classList.add("cyo-sold-out");

          if (!document.querySelector('.cyo-sold-out-message')) {
            const msg = document.createElement('div');
            msg.className = 'cyo-sold-out-message';
            msg.innerText = "All current production slots are filled. Please check back soon.";
            customBtn.parentNode.appendChild(msg);
          }

          return;
        }

        customBtn.disabled = false;
        customBtn.innerText = "Create Your Knife";
        alert("Cart add failed. Check console.");
        return;
      }

      window.location.href = '/cart';
    };
  }

}); // END DOMContentLoaded



// --- Highlight CYO rows in cart ---
function highlightCyoItems() {
  document.querySelectorAll('tr.cart-item').forEach(row => {
    const hasFlag = Array.from(row.querySelectorAll('.product-option')).some(el =>
      el.textContent.includes('_cyo_flag')
    );

    if (hasFlag) {
      row.classList.add('cart-item--cyo');
    }
  });
}

setTimeout(highlightCyoItems, 500);